import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import SwitchButton from "../UIElements/switch-button";
import useResponsive from "../../hooks/useResponsive";

const Notification = () => {
    const isMedium = useResponsive("down", "md", "xs");

  return (
    <Box
      sx={{
        width: isMedium ? "85%" : "550px",
        marginY: 4,
        marginX: 2,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#000E2C",
          fontWeight: 700,
          fontFamily: "Inter",
        }}
      >
        Notification
      </Typography>

      <Box sx={{ my: 4 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between "
        >
          <Typography
            sx={{
              fontFamily: "Lexend",
              fontSize: "14px",
              lineHeight: "23px",
              letterSpacing: "-0.23999999463558197px",
              color: "#000",
              fontWeight: 400,
            }}
          >
            Push Notification
          </Typography>
          <SwitchButton />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between "
        >
          <Typography
            sx={{
              fontFamily: "Lexend",
              fontSize: "14px",
              lineHeight: "23px",
              letterSpacing: "-0.23999999463558197px",
              color: "#000",
              fontWeight: 400,
            }}
          >
            Email Notification
          </Typography>
          <SwitchButton />
        </Stack>
      </Box>
    </Box>
  );
};

export default Notification;
